import { Base } from "survey-core";
import { ComponentContainerModel } from "../component-container/component-container";

export class TabContainerViewModel extends Base {
  public containerModel: ComponentContainerModel;
}